import React from 'react'

const StatusText = ({ children, color }) => (
  <span style={{ fontWeight: 800, textShadow: '1px 1px #eee', color: color }}> {children} </span>
)

export default StatusText
